import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-pharmacy',
    templateUrl: './user-pharmacy.component.html',
    styleUrls: ['./user-pharmacy.component.css'],
    standalone: false
})
export class UserPharmacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
